import { useScrollReveal } from "@/hooks/useScrollReveal";

const values = [
  {
    title: "規律と誇り",
    desc: "社会インフラを守る仕事として、規律と安全意識を最も大切にしています。だからこそ、一人ひとりが誇りを持って現場に立てます。",
    icon: "ri-shield-star-line",
  },
  {
    title: "仲間との団結",
    desc: "チームで動き、コミュニケーションを取り合いながら仕事をします。年齢・経験を超えた仲間との絆がGRANSTARKの強さです。",
    icon: "ri-hand-heart-line",
  },
  {
    title: "働きやすさへのやさしさ",
    desc: "日払い・週払い対応、週シフト制、入社祝い金など。スタッフが安心して長く働ける環境づくりに全力で取り組みます。",
    icon: "ri-heart-3-line",
  },
];

export default function RecruitValueSection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section className="relative py-20 md:py-28 overflow-hidden" id="value">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat pointer-events-none"
        style={{
          backgroundImage:
            "url('/images/GRANSTARK-recruite.html_value_section_back_ground_image.png')",
        }}
      />
      <div className="absolute inset-0 bg-navy/80 pointer-events-none" />
      <div className="relative z-10 w-full px-4 md:px-8 max-w-6xl mx-auto" ref={ref}>
        <div
          className={`transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <div className="text-center mb-14">
            <span className="text-gold text-sm tracking-[3px] font-bold block mb-2">VALUE</span>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">働く上で大切にしていること</h2>
            <h3 className="text-xl md:text-2xl font-bold text-white/90">
              「規律と秩序を守りながらも、楽しく自由に。」
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {values.map((v) => (
              <div
                key={v.title}
                className="bg-white/10 backdrop-blur-md border border-white/15 rounded-2xl p-6 md:p-8 text-center hover:bg-white/15 transition-all duration-300"
              >
                <div className="w-14 h-14 mx-auto rounded-full bg-gold/20 flex items-center justify-center mb-5">
                  <span className="w-7 h-7 flex items-center justify-center text-gold">
                    <i className={`${v.icon} text-2xl`}></i>
                  </span>
                </div>
                <h4 className="text-lg font-bold text-white mb-3">{v.title}</h4>
                <p className="text-gray-300 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}